import { useEffect, useState } from 'react'

import UserTable from '../../component/table/UserTable'
import { Box, Snackbar, Typography } from '@mui/material'
import UserModal from '../../container/UserModal'
import { listUsers } from '../../util/user/UserList'

import _ from 'lodash'
import { UserCreate } from '../../util/user/UserCreate'
import { UserDelete } from '../../util/user/UserDelete'
import { UserStatus } from '../../util/user/UserStatus'
import { UserUpdate } from '../../util/user/UserUpdate'
import { UserPasswordReset } from '../../util/user/UserPasswordReset'
import { getTenantList } from '../../util/tenant/TenantAPIUtil'

const UserTemplate = (props) => {

  const typeList = ["admin","user","product"];

  //UserModalの表示・非表示
  const [openUserModal,setOpenUserModal] = useState(false);

  //更新結果を出すSnackBarの表示・非表示
  const [snackBar,setSnackBar] = useState(false);
  const [snackBarMsg,setSnackBarMsg] = useState("");

  //一覧を取得する際のLoadingイベントを管理する
  const [loading,setLoading] = useState(false);

  //User一覧の値
  const [rowdata,setRowData] = useState([]);

  //追加・更新・削除をする場合にUserModalとのやり取りをするためのデータ構造
  const [selectdata,setSelectData] = useState({});

  //追加・更新・削除をするイベントが発生した場合その対象を管理する構造
  const [updatedata,setUpdatedata] = useState({});

  const [tenantList,setTenatList] = useState([]);

  const [needInit,setNeedInit] = useState(true);

  useEffect(()=>{
    console.log(needInit)
    if(rowdata.length == 0 && needInit){
      setLoading(true);
      getInitialData();
      setNeedInit(false);
    }


  },[rowdata]);

  useEffect(() => {

    //TODO CUD についてFetchを追加する

    if(updatedata.type){

      if(updatedata.type == "update"){
        const diff = _.omitBy(updatedata, (v, k) => selectdata[k] === v)
        const params = {
          diff: diff,
          uid: updatedata.uid,
        }
        updateProcess(typeList[props.index - 1],params);

        setUpdatedata({})
        return;
      }

      if(updatedata.type == "create"){
        console.log("create",updatedata);
        createProcess(typeList[props.index - 1],updatedata);
        setUpdatedata({})
        return;
      }

      if(updatedata.type == "delete"){
        console.log("Delete",updatedata);
        deleteProcess(typeList[props.index - 1], updatedata)
        setUpdatedata({})
        return;
      }

      if(updatedata.type == "available"){
        console.log("available",updatedata);
        statusProcess(typeList[props.index - 1], updatedata)
        setUpdatedata({})
        return;
      }

    }

  },[updatedata])

  const initTenant = async () =>{
    const tenant = await getTenantList();

    const showTenant = tenant.filter((item) => {
      if(props.index == 3){
        return "AdminTenant" == item.name ? true : false;
      }else{
        return "AdminTenant" == item.name ? false : true;
      }
    });

    setTenatList(showTenant);
  };

  const updateProcess = async (type,row) => {
    return processUtil(UserUpdate,type,row,"更新");
  }

  //Create API Call
  const createProcess = async (type,row) => {
    console.log("createProcess",row);
      return processUtil(UserCreate,type,row,"新規追加");
  }
    //Delete API Call
  const deleteProcess = async (type,row) => {
    return processUtil(UserDelete,type,row,"削除");
  };

  const statusProcess = async (type,row) => {
    return processUtil(UserStatus,type,row,"有効無効の変更")
  }

  const processUtil = async (func,type,row,word) => {
    const res = func(type,row);
    if(res){
      setSnackBarMsg(word+"を反映しました")
      setSnackBar(true)
    }else{
      setSnackBarMsg("エラーのため反映ができませんでした。再度実行してください");
      setSnackBar(true)
    }

    return res;

  };

  const getInitialData = async () => {
    const list = await listUsers(typeList[props.index-1]);

    console.log(list);
    //データ処理
    if(list && list.data){
      setRowData(list.data);
    }else{
      setSnackBarMsg("セッション切れあるいは通信エラーのためログイン画面に戻ります")
      setSnackBar(true);
      props.login(false);
    }

    initTenant();
    setLoading(false);
  }

  const createData = () => {
    setSelectData({});
    setOpenUserModal(true);
  } ;

  const onData = (data) => {

    if(!('type' in data)){
      data.type = "create";
      data.isAvailable = true;
      data.entrytime = Date.now();

      setRowData([...rowdata,data]);
    }else{
      //Updateのためデータを入れ替える。
      const newData = rowdata.map((item) => {
        return data.id == item.id ? data : item
      })
      setRowData(newData);
    }

    setUpdatedata(data);

  }


  const updateData = (row) => {
    row.type = "update";
    setSelectData(row);
    setOpenUserModal(true);
  } ;

  const deleteData = (row) => {

    const newData = rowdata.filter((item) => {
      return !(row.id == item.id)
    })

    row.type="delete";
    setUpdatedata(row);
    setRowData(newData);
    console.log("deleteData",row);
  } ;

  const availableData = (row) => {
    const newFlag = !row.isAvailable;
    row.type = 'available';
    const newRow = {
      ...row,
      isAvailable: newFlag,
    };

    const newList = rowdata.map((item) => {
      return row.id == item.id ? newRow : item
    });
    setUpdatedata(newRow);
    setRowData(newList);
  }

  const passwordReset = (params) =>{
    console.log("UserTemplate","PasswordRest",params);
    return processUtil(UserPasswordReset,typeList[props.index-1],params.data,"パスワードリセット");
  };

  return (
    <>
      <Box sx={{mt:3,mb:2}}><Typography variant="h4">{props.title}</Typography> </Box>
      <UserTable loading={loading} data={rowdata} create={createData}  update={updateData} delete={deleteData} available={availableData} passreset={passwordReset} tenantlist={tenantList} />
      <UserModal open={openUserModal} setOpen={setOpenUserModal} title={"ユーザ登録/更新"} datafunc={onData} tenantlist={tenantList} data={selectdata}/>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={snackBar}
        onClose={()=>{setSnackBar(false)}}
        message={snackBarMsg}
        key='useradd'
      />
    </>
  );
};

export default UserTemplate;